import { Fragment, useState } from 'react';

import { Link } from '@hh.ru/redux-spa-middleware';

import Button, { ButtonKind } from 'bloko/blocks/button';
import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import CreateInvoiceModal from 'components/Admin/Payers/CreateInvoiceModal';
import Filter from 'components/Admin/Payers/Filter';
import Payer from 'components/Admin/Payers/Payer';
import Spinner from 'components/Admin/Spinner';
import TitlePage from 'components/Admin/TitlePage';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

import 'components/Admin/Payers/Payers.less';

const Payers = () => {
    const { isLoad, payers } = useSelector((state) => state.payers);
    const trl = useTrls();

    const [visibleCreateInvoice, setVisibleCreateInvoice] = useState(false);

    return (
        <Fragment>
            <TitlePage>{trl('admin.SectionTabs.payers')}</TitlePage>
            <Gap top bottom>
                <div className="payer-create-button">
                    <Button Element={Link} to="/new/admin/payer/create" kind={ButtonKind.Success}>
                        {trl('admin.Payers.create')}
                    </Button>
                </div>
            </Gap>
            <Gap top bottom>
                <Filter />
            </Gap>
            {!isLoad && (
                <Table withStripes bordered fullWidth>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell>{trl('admin.Users.Header.user')}</TableHeadCell>
                            <TableHeadCell>{trl('admin.Users.Header.account')}</TableHeadCell>
                            <TableHeadCell colSpan={2}>{trl('admin.Payers.Header.payer')}</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payers.map((payer) => (
                            <Payer key={payer.payerId} {...payer} setVisibleCreateInvoice={setVisibleCreateInvoice} />
                        ))}
                    </TableBody>
                </Table>
            )}
            {isLoad && <Spinner />}
            <CreateInvoiceModal visible={visibleCreateInvoice} setVisible={setVisibleCreateInvoice} />
        </Fragment>
    );
};

export default Payers;
